import React, {Fragment, useState, useEffect, useRef} from 'react';
import {Form, Field} from 'react-final-form';
import TextField from '@material-ui/core/TextField';
import {Popup, Text, Select, Explanation_text, TextEditor} from '../../../components';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {connect} from 'react-redux';

function Email_address_popup(props){
  const[editor_type, setEditorType]=useState('Html');
  const[reply_to_address, setReplyToAddress]=useState(false);
  let first_time=useRef(true);
  let first_time_ra=useRef(true);
  function onSubmit(params){
    console.log(editor_type);
    console.log(params, 'PARAMS');
    if(reply_to_address==false){params.reply_to_address=undefined;}
    if(params.email_signature!=undefined && editor_type=='Html'){params.email_signature.signature=params.email_signature.signature_html; params.email_signature.html_input=true;}else if(params.email_signature!=undefined){params.email_signature.html_input=false;}
    if(params.id==undefined){props.createEmailAddress(params);}
    else{props.updateEmailAddress(params);}
  }

  let initial_values=JSON.parse(JSON.stringify(props.email_address)); if(initial_values=='NEW'){initial_values=undefined;}else if(initial_values.email_signature!=undefined){if(initial_values.email_signature.html_input==false && first_time.current==true){setEditorType('Text editor'); first_time.current=false;}else if(initial_values.email_signature.html_input==true && first_time.current==true){ first_time.current=false; initial_values.email_signature.signature_html=initial_values.email_signature.signature; initial_values.email_signature.signature=undefined}}

  let smtp_logins=[];
  for(let sl of props.gmail.smtp_logins){if(initial_values!=undefined){}else{initial_values={smtp_login_id:sl.id}} smtp_logins.push({id:sl.id, name:sl.username});}
  if(first_time_ra.current==true && initial_values.reply_to_address!=undefined){first_time_ra.current=false; setReplyToAddress(true);}

  return(
    <Form
      onSubmit={onSubmit}
      initialValues={initial_values}
    >
      {form_props => (
        <form onSubmit={form_props.handleSubmit}>
        <Popup  maxWidth='900px' handleClose={props.handleClose} accept_button='Save' accept_button_click={()=>{form_props.form.submit(); form_props.form.reset(); props.handleClose();}}  always_open title={(props.email_address=='NEW')?'email_address_popup_title':'email_address_update_popup_title'} content={
          <div style={{width:'800px', minHeight:'300px', position:'relative', marginLeft:'20px', marginRight:'20px', marginBottom:'20px'}}>
          <Grid container style={{marginTop:'10px'}}>
            <Grid item xs={6}><div style={{width:'calc(100% - 20px)', marginLeft:'-10px'}}><Text variant='outlined' size='small' title='Email' name='email'/></div></Grid>
            <Grid item xs={6}><div style={{width:'calc(100% - 20px)', marginLeft:'10px'}}><Field name='main'>{(f)=><FormControlLabel label='Main' control={<Checkbox checked={f.input.value} onChange={f.input.onChange} color="secondary"/>}/>}</Field></div></Grid>
            <Grid item xs={6}><div style={{width:'calc(100% - 20px)', marginLeft:'-10px'}}><Text variant='outlined' size='small' title='Sender name' name='sender_name'/></div></Grid>
            <Grid item xs={6}/>
            {(smtp_logins.length>1)?<Grid item xs={6}><div style={{width:'calc(100% - 20px)', marginLeft:'-10px', marginTop:'10px'}}><Select title='SMTP' select_data={smtp_logins} name='smtp_login_id'/></div></Grid>:null}
            <Grid item xs={12}><FormControlLabel control={<Checkbox style={{marginLeft:'0px'}} checked={reply_to_address} onChange={(e)=>{setReplyToAddress(e.target.checked);}} name="reply_to_address" color="primary"/>} label="Receive replies on a different address"/></Grid>
            <Grid item xs={12}>{(reply_to_address==false)?null:<Typography variant='caption' style={{marginTop:'10px'}}>When sending templates with a default reply to address, that reply to address will take presidence over this one.</Typography>}</Grid>

            <Grid item xs={6}>{(reply_to_address==false)?null:
              <div style={{width:'calc(100% - 20px)', marginLeft:'-10px', marginTop:'10px'}}><Text required title='Receive replies on this address' name='reply_to_address' size='small' variant='outlined'/></div>
            }</Grid>

          </Grid>
            <hr style={{width:'100%', marginTop:'10px'}}/>
            <Typography color='primary' style={{marginBottom:'-10px', marginTop:'10px'}}>{'Signature (optional: '+editor_type+')'}</Typography>
            <div style={{height:'20px'}}/>
            <div style={{marginTop:'10px', marginBottom:'10px', textDecoration:'underline'}} onClick={()=>{if(editor_type=='Html'){setEditorType('Text editor');}else{setEditorType('Html');}}}>{(editor_type=='Html')?'Text editor':'Html'}</div>
              <Field name='email_signature.name'>{(f)=><TextField value={f.input.value} onChange={f.input.onChange} variant='outlined' size='small' label='Signature name' name='signature.name'/>}</Field>
              <div style={{height:'10px'}}/>
              {(editor_type=='Html')?<Field name='email_signature.signature_html'>{(f)=>{
                return(
                <div style={{width:'100%'}}>
                  <TextField size='small' multiline rows={5} label='Paste HTML here' variant='outlined' style={{width:'550px'}} value={f.input.value} onChange={f.input.onChange} name='signature.signature'/>

                  <div style={{marginTop:'20px', width:'550px', position:'relative'}} dangerouslySetInnerHTML={{__html:f.input.value}}></div>
                </div>
              )
            }}</Field>:<Field name='email_signature.signature'>{(f)=><TextEditor value={f.input.value} onChange={f.input.onChange} name='signature.signature'/>}</Field>}

          </div>
        }/>
        </form>
      )}
    </Form>
  );
}


export default connect(ss, dd)(Email_address_popup);

function ss(state){
  return{}
}

function dd(dispatch){
  return{
    createEmailAddress:(params)=>{dispatch({type:'REQUEST_CREATE_EMAIL_ADDRESS', payload:params})},
    updateEmailAddress:(params)=>{dispatch({type:'REQUEST_UPDATE_EMAIL_ADDRESS', payload:params})}
  }
}
